import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import area from '@turf/area';

export const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const selectedAddress = (addresses, id) => addresses.find((a) => a.id === id) || addresses.find((a) => a.default) || addresses[0];

export const findNeighborhood = (coverage, destination = {}) => {
  if (destination.location) {
    const point = [destination.location.lng, destination.location.lat];
    return coverage.filter((c) => c.active && c.geometry && booleanPointInPolygon(point, c.geometry))
      .sort((a, b) => (a.geometryArea ?? area(a.geometry)) - (b.geometryArea ?? area(b.geometry)) || a.id.localeCompare(b.id))[0];
  }
  if (destination.coverageId) return coverage.find((c) => c.active && c.id === destination.coverageId);
  if (!destination.barrio) return undefined;
  const norm = (s) => s.trim().toLowerCase();
  const matches = coverage.filter((c) => c.active && norm(c.barrio) === norm(destination.barrio) && (!destination.city || norm(c.city) === norm(destination.city)));
  return matches.length === 1 ? matches[0] : undefined;
};

export const deliveryPrice = (base, destination, coverage, settings, pickup = false) => {
  if (pickup) return { baseDeliveryFee: 0, neighborhoodFee: 0, deliveryFee: 0, feeSource: 'pickup' };
  if (!settings) return null;
  const zone = findNeighborhood(coverage, destination);
  const configured = zone?.deliveryFee != null;
  const neighborhoodFee = roundMoney(configured ? zone.deliveryFee : settings.defaultNeighborhoodFee);
  const baseDeliveryFee = roundMoney(base || 0);
  return { baseDeliveryFee, neighborhoodFee, deliveryFee: roundMoney(baseDeliveryFee + neighborhoodFee), feeSource: configured ? 'neighborhood' : 'default', barrio: zone?.barrio, coverageId: zone?.id };
};

export const validFee = (value) => value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 && Math.abs(Number(value) * 100 - Math.round(Number(value) * 100)) < 0.000001;